import { render, staticRenderFns } from "./help-guide.vue?vue&type=template&id=738d4f0e&"
import script from "./help-guide.vue?vue&type=script&lang=js&"
export * from "./help-guide.vue?vue&type=script&lang=js&"
import style0 from "./help-guide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconChevron: require('/usr/src/app/components/icons/icon-chevron.vue').default,Chevron: require('/usr/src/app/components/account/common-elements/icons/chevron.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default})
